const marked = require('marked');

function md(value) {
  if (!value) {
    return value;
  }

  return marked.parse(value);
}

module.exports = md;



// WEBPACK FOOTER //
// ./src/libs/twig/md/index.js